import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './modules/attendance/Home';
import AttendanceLog from './modules/attendance/AttendanceLog';
import Leaves from './modules/leaves/Leaves';
import Salary from './modules/salary/Salary';
import Profile from './modules/profile/Profile';
import Layout from './components/layout/Layout';
import Login from './modules/auth/Login';
import HRDashboard from './modules/hr/HRDashboard';
import './App.css';

function App() {
  const [employee, setEmployee] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem('employee');
    const token = localStorage.getItem('token');
    if (saved && token) {
      setEmployee(JSON.parse(saved));
    }
  }, []);

  const handleLogin = (emp) => setEmployee(emp);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('employee');
    setEmployee(null);
  };

  if (!employee) return <Login onLogin={handleLogin} />;

  if (employee.role === 'hr' || employee.role === 'admin') {
    return (
      <Router>
        <Routes>
          <Route path="/hr/*" element={<HRDashboard employee={employee} onLogout={handleLogout} />} />
          <Route path="*" element={<Navigate to="/hr" />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Layout employee={employee} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Home employee={employee} />} />
          <Route path="/log" element={<AttendanceLog employee={employee} />} />
          <Route path="/leaves" element={<Leaves employee={employee} />} />
          <Route path="/salary" element={<Salary employee={employee} />} />
          <Route path="/profile" element={<Profile employee={employee} onLogout={handleLogout} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;